import { useTranslation } from '../../core/hooks/use-translation';
import { Card } from '../../ui/card';
import { Skeleton } from '../../ui/skeleton';

/** The case page's own shape while its reads are in flight, so nothing jumps when it arrives. */
export function CasePageSkeleton() {
    const { t } = useTranslation();

    return (
        <div role="status" aria-live="polite" className="mx-auto max-w-6xl px-4 py-8 sm:py-12">
            <span className="sr-only">{t('portal.loading')}</span>

            <div className="flex items-center justify-between gap-3">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-8 w-32 rounded-xl" />
            </div>

            <Card className="mt-4 overflow-hidden">
                <div className="space-y-4 p-5 sm:p-7">
                    <Skeleton className="h-6 w-64 max-w-full" />
                    <Skeleton className="h-9 w-3/4" />
                    <Skeleton className="mt-6 h-2 rounded-full" />
                </div>

                <div className="border-t border-slate-200/80 px-5 py-5 sm:px-7 dark:border-slate-800">
                    <Skeleton className="h-11 w-2/3" />
                </div>
            </Card>

            <div className="mt-6 grid items-start gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
                <Card>
                    <div className="space-y-4 p-5">
                        <Skeleton className="h-5 w-40" />
                        <Skeleton className="h-14" />
                        <Skeleton className="h-14" />
                    </div>
                </Card>

                <Card>
                    <div className="space-y-4 p-5">
                        <Skeleton className="h-5 w-28" />
                        <Skeleton className="h-7" />
                        <Skeleton className="h-7" />
                        <Skeleton className="h-7" />
                    </div>
                </Card>
            </div>
        </div>
    );
}
